import { render } from "./CategorySettingView.vue?vue&type=template&id=4dc23f41"
import script from "./CategorySettingView.vue?vue&type=script&lang=js"
export * from "./CategorySettingView.vue?vue&type=script&lang=js"

import "./CategorySettingView.vue?vue&type=style&index=0&id=4dc23f41&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__